import getConfig from 'next/config';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  FacebookShareButton,
  LineShareButton,
  TwitterShareButton,
} from 'react-share';
import {
  FacebookSvg,
  LineSvg,
  ShareLinkSvg,
  TwitterSvg,
} from './assets/ShareItemSvg';
import { ShareItemsWrapper } from './ShareItems.style';

const { publicRuntimeConfig } = getConfig();
const baseUrl = publicRuntimeConfig.baseUrl;

interface Props {
  asPath: string;
  deviceType: string;
  title?: string;
}

const ShareItems = (props: Props): React.ReactElement => {
  const { asPath, deviceType } = props;
  const shareUrl = `${baseUrl}${asPath.substring(1)}`;

  return (
    <div data-test={'desktop-share-items'}>
      <ShareItemsWrapper deviceType={deviceType}>
        <div className="share-item-wrapper">
          <LineShareButton url={shareUrl} className="share-item-button">
            <LineSvg />
          </LineShareButton>
        </div>
        <div className="share-item-wrapper">
          <FacebookShareButton url={shareUrl} className="share-item-button">
            <FacebookSvg />
          </FacebookShareButton>
        </div>
        <div className="share-item-wrapper">
          <TwitterShareButton url={shareUrl} className="share-item-button">
            <TwitterSvg />
          </TwitterShareButton>
        </div>
        <div className="share-item-wrapper">
          <CopyToClipboard text={shareUrl}>
            <div className="share-item-button">
              <ShareLinkSvg />
            </div>
          </CopyToClipboard>
        </div>
      </ShareItemsWrapper>
    </div>
  );
};

export default ShareItems;
